import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import normalbrowser from "../../../../assets/images/docs/normalbrowser-like.png";
import browserextension from "../../../../assets/images/docs/helper/helpericon.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  normalbrowser,
  browserextension,
  React
};